import { defineAbility } from '@casl/ability';

/**
 * Define abilities for the user based on their permissions
 * @param {Object} user - The user object
 * @param {Array} permissions - Array of permission objects with action and subject
 * @returns {Object} - CASL Ability instance
 */
export const defineAbilityFor = (user, permissions = []) => {
  // If no user or permissions, return empty ability
  if (!user) {
    return defineAbility(() => {});
  }

  return defineAbility((can) => {
    // Superadmin and Admin can manage all (backend handles specific restrictions)
    if (user.role === 'superadmin' || user.role === 'admin') {
      can('manage', 'all');
      return;
    }

    // Add permissions from the backend
    permissions.forEach(permission => {
      can(permission.action, permission.subject);
    });
  });
};
